import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

// 🔹 Main Pages
const Home = lazy(() => import("../pages/Home"));
const About = lazy(() => import("../pages/About"));
const Services = lazy(() => import("../pages/Services"));
const MutualFundsSip = lazy(() => import("../pages/MutualFundsSip"));
const FinancialSolutions = lazy(() => import("../pages/FinancialPlanning"));
const PMSAIF = lazy(() => import("../pages/PMSAIF"));
const SIF = lazy(() => import("../pages/SIF"));
const RetirementPlanning = lazy(() => import("../pages/RetirementPlanning"));
const P2PInvesting = lazy(() => import("../pages/P2PInvesting"));
const VideoGallery = lazy(() => import("../pages/VideoGallery"));
const Contact = lazy(() => import("../pages/Contact"));
const Login = lazy(() => import("../pages/Login"));
const KnowYourStory = lazy(() => import("../pages/KnowYourStory"));

// 🔹 Legal / Policy Pages
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("../pages/TermsOfService"));
const Disclaimer = lazy(() => import("../pages/Disclaimer"));
const CommissionDisclosure = lazy(() => import("../pages/CommissionDisclosure"));

// 🔹 Calculator Pages
const Calculator = lazy(() => import("../pages/Calculator"));
const SIPCalculator = lazy(() => import("../components/calculators/SIPCalculator"));
const LumpsumCalculator = lazy(() => import("../components/calculators/LumpsumCalculator"));
const STPCalculator = lazy(() => import("../components/calculators/STPCalculator"));
const SWPCalculator = lazy(() => import("../components/calculators/SWPCalculator"));
const RetirementCalculator = lazy(() => import("../components/calculators/RetirementCalculator"));
const DelayCalculator = lazy(() => import("../components/calculators/DelayCalculator"));
const InsuranceCalculator = lazy(() => import("../components/calculators/InsuranceCalculator"));
const EMICalculator = lazy(() => import("../components/calculators/EMICalculator"));
const TaxCalculator = lazy(() => import("../components/calculators/TaxCalculator"));
const MarriageCalculator = lazy(() => import("../components/calculators/MarriageCalculator"));
const EducationCalculator = lazy(() => import("../components/calculators/EducationCalculator"));
const HomeLoanCalculator = lazy(() => import("../components/calculators/HomeLoanCalculator"));
const CarLoanCalculator = lazy(() => import("../components/calculators/CarLoanCalculator"));
const VacationCalculator = lazy(() => import("../components/calculators/VacationCalculator"));

const AppRoutes = () => (
  <Suspense fallback={<div className="text-center py-20 text-gray-600 text-lg">Loading...</div>}>
    <Routes>
      {/* 🌐 Main Website Pages */}
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/knowyourstory" element={<KnowYourStory />} />
      <Route path="/services" element={<Services />} />
      <Route path="/mutual-funds-sip" element={<MutualFundsSip />} />
      <Route path="/financial-solutions" element={<FinancialSolutions />} />
      <Route path="/pms-aif" element={<PMSAIF />} />
      <Route path="/sif" element={<SIF />} />
      <Route path="/retirement-planning" element={<RetirementPlanning />} />
      <Route path="/p2p-investing" element={<P2PInvesting />} />
      <Route path="/video-gallery" element={<VideoGallery />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<Login />} />

      {/* ⚖️ Legal & Policy Pages */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/commission-disclosure" element={<CommissionDisclosure />} />

      {/* 🧮 Calculators Overview Page */}
      <Route path="/calculator" element={<Calculator />} />

      {/* 📊 Individual Calculator Pages */}
      <Route path="/calculator/sip" element={<SIPCalculator />} />
      <Route path="/calculator/lumpsum" element={<LumpsumCalculator />} />
      <Route path="/calculator/stp" element={<STPCalculator />} />
      <Route path="/calculator/swp" element={<SWPCalculator />} />
      <Route path="/calculator/retirement" element={<RetirementCalculator />} />
      <Route path="/calculator/delay" element={<DelayCalculator />} />
      <Route path="/calculator/insurance" element={<InsuranceCalculator />} />
      <Route path="/calculator/emi" element={<EMICalculator />} />
      <Route path="/calculator/tax" element={<TaxCalculator />} />
      <Route path="/calculator/marriage" element={<MarriageCalculator />} />
      <Route path="/calculator/education" element={<EducationCalculator />} />
      <Route path="/calculator/home-loan" element={<HomeLoanCalculator />} />
      <Route path="/calculator/car-loan" element={<CarLoanCalculator />} />
      <Route path="/calculator/vacation" element={<VacationCalculator />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
